import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/AddProperty.css";

function AddProperty() {

  const navigate = useNavigate();

  const [form, setForm] = useState({
    location: "",
    price: "",
    postedBy: "",
    status: "",
    listingType: "",
    property_type: "",
    images: [],
  });

  const [error, setError] = useState("");
  const [uploading, setUploading] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleImageChange = async (e) => {
    setUploading(true);
    const files = Array.from(e.target.files);

    if (files.length > 5) {
      setError("Maximum 5 images allowed");
      return;
    }

    let uploadedImages = [];

    for (let file of files) {

      if (file.size > 5 * 1024 * 1024) {
        setError("Each image must be less than 5MB");
        setUploading(false);
        return;
      }

      const formData = new FormData();
      formData.append("image", file);

      try {

        const res = await fetch(
          "https://urbanbrick.in.net/upload.php",
          {
            method: "POST",
            body: formData
          }
        );

        const data = await res.json();
         

        if (data.status === "success" && (data.url || data.image)) {
          uploadedImages.push(data.url || data.image);
        } else {
          alert(data.message || "Image upload failed");
        }

      } catch (error) {
        console.log(error);
        alert("Upload error");
      }

    }

    setForm(prev => ({
      ...prev,
      images: [...prev.images, ...uploadedImages]
    }));

    setUploading(false);

    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (uploading) {
      alert("Please wait, images are uploading...");
      return;
    }

    if (!form.images || form.images.length === 0) {
      alert("Please upload at least one image");
      return;
    }

    try {

      const res = await fetch(
        "https://urbanbrick.in.net/save-property.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(form)
        }
      );

      const data = await res.json();

      if (data.status === "success") {

        alert("Property Added Successfully!");
        navigate("/admin/dashboard");

      } else {
        alert(data.message || "Save failed");
      }

    } catch (error) {
      console.log(error);
      alert("Server Error");
    }
  };

  return (

    <div className="add-container">

      <div className="form-card">

        <h2>Add New Property</h2>

        <form onSubmit={handleSubmit}>

          <input
              type="text"
              name="location"
              placeholder="Enter Address (max 50 words)"
              value={form.location}
              onChange={(e) => {
                const text = e.target.value;
                 const words = text.trim().split(/\s+/);

                  if (words.length <= 50) {
                     setForm({
                               ...form,
                              location: text
                             });
                     setError("");
                      } else {
                  setError("Maximum 50 words allowed for address");
                     }
                     }}
                     required
              />

          <input
            name="price"
            placeholder="Price Range"
            value={form.price}
            onChange={handleChange}
            required
          />

          <input
             name="property_type"
             placeholder="Property Type (Flat / Villa / Apartment)"
             value={form.property_type}
             onChange={handleChange}
              required
          />

          <input
            name="postedBy"
            placeholder="Posted By (Agent / Owner)"
            value={form.postedBy}
            onChange={handleChange}
            required
          />

          <select
            name="status"
            value={form.status}
            onChange={handleChange}
            required
          >
            <option value="">Select Status</option>
            <option value="Active">Active</option>
            <option value="Closed">Closed</option>
          </select>

          <select
            name="listingType"
            value={form.listingType}
            onChange={handleChange}
            required
          >
            <option value="">Property Listing</option>
            <option value="Buy">Buy</option>
            <option value="Sell">Sell</option>
            <option value="Rent">Rent</option>
          </select>

          <label className="file-upload">
            Upload Images (Max 5)
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={handleImageChange}
            />
          </label>

          {error && <p className="error">{error}</p>}

          <button type="submit">
            {uploading ? "Uploading..." : "Add Property"}
          </button>

        </form>

      </div>

    </div>

  );
}

export default AddProperty;